import probes from '@xl/sec-sign-sdk';

const carStickerCoupeId = '2ab6cb23a8ed4ad2be9b016811415cd8';

const judgeEnv = () => {
  const { host } = location;
  if (process.env.NODE_ENV === 'development' || /-stg/.test(host)) {
    return 'stg';
  }
  if (/-pre/.test(host)) {
    return 'pre';
  }
  return 'prd';
};

const env = judgeEnv();

const envStr = `${env === 'prd' ? '' : `-${env}`}`;

const allowList = [`dcs-driver${envStr}.xiaolachuxing.com`];
// 安全sdk
probes.init({ allowList });

const getCoupeUrl = coupeId => {
  return env === 'prd'
    ? `https://coupe-static.xiaolachuxing.com/schema/${coupeId}_data.json`
    : `https://coupe-api.xlcx.work/schema/${env}/${coupeId}_data.json`;
};

// 获取需要重定向模板的Coupe配置
const getCoupeSettingCode = async () => {
  try {
    const coupeUrl = getCoupeUrl(carStickerCoupeId);
    const {
      data: { grayTplCode = [] }
    } = (await fetch(coupeUrl).then(res => res.json())) || {};
    return grayTplCode;
  } catch (error) {
    console.log(error, 'coupe获取配置模板code失败');
  }
  return [];
};

const getIsGrayRegion = async () => {
  const url =
    env === 'prd'
      ? `https://dcs-driver.xiaolachuxing.com/api`
      : `https://dcs-driver-${env}.xiaolachuxing.com/api`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: 'is.qrcode.visitor.from.gray.area',
        version: '1.0'
      })
    }).then(res => res.json());
    if (res.ret === 0 && res.data) {
      return res.data.isSpecifyArea;
    }
  } catch (error) {
    console.log(error, '获取灰度城市失败');
  }
  return false;
};

// 目前需要重定向的模板 是灰度城市+code存在在coupe配置
export const hackXlCarStikcerTpl = async tplCode => {
  const [grayTplCode, isGray] = await Promise.all([
    getCoupeSettingCode(),
    getIsGrayRegion()
  ]);

  if (grayTplCode.includes(tplCode) && isGray) {
    window.location.href =
      env === 'prd'
        ? 'https://driver-h5.xiaolachuxing.com/driver/car-sticker?from=xiaola'
        : `https://driver-v-${env}.xiaolachuxing.com/car-sticker?from=xiaola`;
  }
};
